import React from 'react';
import { Typography } from '@mui/material';

import { Title, CompletedSurveyWrapper } from './styles';
import { ReactComponent as CircularCheckIcon } from 'images/dashboard/circular-green-check.svg';

const Completed = () => (
  <CompletedSurveyWrapper>
    <CircularCheckIcon />
    <Title
      variant='h6'>You’ve completed the survey for today</Title>
    <Typography
      variant='pl3'>Thanks for participating</Typography>
  </CompletedSurveyWrapper>
);

export default Completed;
